import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PageHeader from "../../components/PageHeader";
import { apiCall, formattedPrice } from "../../helpers/MainHelper";
import ReactLoading from "react-loading";
import withPermissions from "../../components/WithPermissions";
import Swal from "sweetalert2";
import ReactDOMServer from "react-dom/server";
class InvoiceDetail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            invoice: {},
            invoice_content: '',
            tevkifat: [],
            modalOpen: false,
            formData: {
                invoice_id: '',
                due_date: '',
                payment_status: '',
                description: '',
            },
            selectedTevkifat: '',
            showTevkifatForm: null,
            isLoad: true,
            loading: false,
            tevLoading: false,
            invoiceLoading: false,
            createInvoiceLoading: false,
            invoiceDraftLoading: false,
            invoiceConfirmLoading: false,
            invoiceOperationID: '',
            showInvoiceConfirm: false,
            updateInvoiceLoading: false,
            invoiceDraftDeleteLoading: false,
            cities: [],
            districts: [],
            currentCredit: ''
        }
    }
    componentDidMount() {
        this.getInvoiceInfo();
        this.getCities();
        this.getCurrentCredit();
    }
    getCurrentCredit = async () => {
        try {
            const response = await apiCall('business/ksoft/current-credit', 'get', null);
            this.setState({ currentCredit: response }, () => {
                this.setState({ isLoad: false })
            });
        } catch (e) {
            console.log(e);
            this.setState({ isLoad: false });
        }
    }
    getInvoiceInfo = async () => {
        // ✅ İKİ FARKLI ROUTE DESTEĞİ:
        // 1. /invoice/:operation_id/:customer_id → createTempInvoice (service details için)
        // 2. /invoice-detail/:invoice_id → direkt invoice getir (tablo için)

        const invoiceID = this.props.match.params.invoice_id;  // Yeni route için
        const operationID = this.props.match.params.id;         // Eski route için
        const customerID = this.props.match.params.customer_id; // Eski route için

        try {
            let response;

            if (invoiceID) {
                // ✅ TABLO'DAN GELİYOR: Direkt invoice_id ile getir
                response = await apiCall('business/ksoft/invoice/' + invoiceID, 'get', null);
            } else if (operationID && customerID) {
                // ✅ SERVICE DETAILS'DEN GELİYOR: createTempInvoice çağır
                response = await apiCall('business/ksoft/create/temp/' + operationID + '/' + customerID, 'get', null);
            } else {
                throw new Error('Geçersiz route parametreleri');
            }

            this.setState({ invoice: response, isLoad: false });
            this.setState(prevState => ({
                formData: {
                    ...prevState.formData,
                    due_date: response.due_date,
                    invoice_id: invoiceID,
                    payment_status: response.payment_status === "Ödenmedi" ? "unpaid" : "paid",
                    description: response.description || ''
                }
            }))

        } catch (e) {
            console.error('Invoice loading error:', e);
            this.setState({ isLoad: false });
        }
    }
    getCities = async () => {
        const response = await apiCall('get-cities', 'get', null);
        const tevkifatOptions = JSON.parse(localStorage.getItem('tevkifatOptions'));
        if (tevkifatOptions) {
            this.setState({ tevkifat: tevkifatOptions });
        }
        this.setState({ cities: response });
    }

    handleInvoiceChange = (event) => {
        const { id, value } = event.target;
        this.setState(prevState => ({
            formData: {
                ...prevState.formData,
                [id]: value
            }
        }));
    };

    handleConfirmInvoice = async () => {
        const { invoice } = this.state;
        
        // E-Arşiv fatura ise gönderim şeklini sor
        let sendingType = null;
        if (invoice.documentType === 'EARSIVFATURA' || invoice.documentType === 'EARSIV') {
            const sendingTypeResult = await Swal.fire({
                title: 'E-Arşiv Gönderim Şekli',
                html: `
                    <div style="text-align: left; padding: 10px;">
                        <p style="margin-bottom: 15px; color: #666; font-size: 14px;">
                            E-Arşiv faturanızın gönderim şeklini seçiniz:
                        </p>
                        <div style="display: flex; flex-direction: column; gap: 12px;">
                            <label style="display: flex; align-items: center; padding: 15px; border: 2px solid #e0e0e0; border-radius: 8px; cursor: pointer; transition: all 0.3s;" onmouseover="this.style.borderColor='#007bff'; this.style.background='#f8f9ff';" onmouseout="this.style.borderColor='#e0e0e0'; this.style.background='white';">
                                <input type="radio" name="sendingType" value="ELEKTRONIK" checked style="margin-right: 12px; width: 18px; height: 18px; cursor: pointer;">
                                <div style="flex: 1;">
                                    <strong style="display: block; color: #333; font-size: 15px; margin-bottom: 4px;">
                                        <i class="fa fa-envelope" style="color: #007bff; margin-right: 6px;"></i> Elektronik Gönderim
                                    </strong>
                                    <small style="color: #666; display: block; line-height: 1.4;">
                                        Fatura e-posta, SMS veya diğer elektronik ortamlar ile müşteriye gönderilecek
                                    </small>
                                </div>
                            </label>
                            <label style="display: flex; align-items: center; padding: 15px; border: 2px solid #e0e0e0; border-radius: 8px; cursor: pointer; transition: all 0.3s;" onmouseover="this.style.borderColor='#ff9800'; this.style.background='#fff8f0';" onmouseout="this.style.borderColor='#e0e0e0'; this.style.background='white';">
                                <input type="radio" name="sendingType" value="KAGIT" style="margin-right: 12px; width: 18px; height: 18px; cursor: pointer;">
                                <div style="flex: 1;">
                                    <strong style="display: block; color: #333; font-size: 15px; margin-bottom: 4px;">
                                        <i class="fa fa-file-text-o" style="color: #ff9800; margin-right: 6px;"></i> Kağıt Gönderim
                                    </strong>
                                    <small style="color: #666; display: block; line-height: 1.4;">
                                        Fatura fiziksel (kağıt) olarak müşteriye teslim edilecek
                                    </small>
                                </div>
                            </label>
                        </div>
                        <div style="margin-top: 15px; padding: 12px; background: #f0f7ff; border-left: 4px solid #007bff; border-radius: 4px;">
                            <small style="color: #0056b3; font-size: 12px; line-height: 1.5;">
                                <i class="fa fa-info-circle" style="margin-right: 4px;"></i>
                                <strong>Not:</strong> Gönderim şekli GİB tarafından E-Arşiv faturalar için zorunludur.
                            </small>
                        </div>
                    </div>
                `,
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: '<i class="fa fa-arrow-right"></i> Devam Et',
                cancelButtonText: '<i class="fa fa-times"></i> İptal',
                confirmButtonColor: '#007bff',
                cancelButtonColor: '#6c757d',
                width: '550px',
                preConfirm: () => {
                    const selectedRadio = document.querySelector('input[name="sendingType"]:checked');
                    if (!selectedRadio) {
                        Swal.showValidationMessage('Lütfen bir gönderim şekli seçiniz!');
                        return false;
                    }
                    return selectedRadio.value;
                }
            });

            if (!sendingTypeResult.isConfirmed) {
                return; // İptal edildi
            }
            
            sendingType = sendingTypeResult.value;
        }

        const result = await Swal.fire({
            title: 'Uyarı',
            text: "Faturayı göndermek istediğinize emin misiniz?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Evet,Resmileştir!',
            cancelButtonText: 'İptal et',
            preConfirm: async () => {
                const confirmButton = Swal.getConfirmButton();
                const originalButtonText = confirmButton.innerHTML;
                confirmButton.disabled = true;
                confirmButton.innerHTML = ReactDOMServer.renderToString(<ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />);

                try {
                    const payload = sendingType ? { sending_type: sendingType } : null;
                    await apiCall('business/ksoft/send-invoice/' + this.state.invoice.id, 'post', payload);
                    await this.getInvoiceInfo();
                    await this.getCurrentCredit();
                    return true;
                } catch (error) {
                    return false;
                } finally {
                    confirmButton.innerHTML = originalButtonText;
                    confirmButton.disabled = false;
                }
            }
        });

        if (result.isConfirmed) {
            if (result.value) {
                Swal.fire(
                    'Uyarı!',
                    'Fatura resmileştirme başarıyla işleme alındı.',
                    'success'
                );
            } else {
                Swal.fire(
                    'Hata!',
                    'Bir sorun oluştu. Lütfen daha sonra tekrar deneyiniz.',
                    'error'
                );
            }
        }
    }
    calculateTotals = () => {
        const { invoice } = this.state;

        let totalCost = 0;
        let totalPrice = 0;
        let totalWithKdv = 0;
        let totalKdv = 0;
        let totalDiscount = 0;
        let totalWithholding = 0;
        let withholdingRate = 0;

        if (invoice.operation && invoice.operation.process) {
            const parseWitholding = invoice.operation && invoice.operation.withholding ? JSON.parse(invoice.operation.withholding) : [];
            withholdingRate = Object.keys(parseWitholding).length > 0 ? parseFloat(parseWitholding[0].rate) : 0;

            JSON.parse(invoice.operation.process).forEach((process) => {
                const cost = parseFloat(process.cost) || 0;
                const quantity = parseFloat(process.quantity) || 0;
                const price = parseFloat(process.price) || 0;
                const kdvRate = parseFloat(process.kdv) || 0;
                const discountRate = parseFloat(process.discount) || 0;

                const discount = (price * quantity * discountRate) / 100;
                totalCost += cost * quantity;
                totalPrice += price * quantity;
                totalDiscount += discount;

                const discountedPrice = (price * quantity) - discount;
                const kdvAmount = (discountedPrice * kdvRate) / 100;

                totalKdv += kdvAmount;
                totalWithKdv += discountedPrice + kdvAmount;

                const withholdingAmount = (kdvAmount * withholdingRate) / 100;
                totalWithholding += withholdingAmount;

                totalWithKdv -= withholdingAmount;
            });

            totalCost = totalCost.toFixed(2);
            totalPrice = totalPrice.toFixed(2);
            totalWithKdv = totalWithKdv.toFixed(2);
            totalKdv = totalKdv.toFixed(2);
            totalDiscount = totalDiscount.toFixed(2);
            totalWithholding = totalWithholding.toFixed(2);
        }

        return { totalCost, totalPrice, totalWithKdv, totalKdv, totalDiscount, totalWithholding, withholdingRate };
    };
    openCustomerDetail = (e) => {
        e.preventDefault();
        const link = `${process.env.PUBLIC_URL}/customer-detail/${this.state.invoice.customer_id}`
        window.open(link, "_blank");
    }
    showInvoice = async (e) => {
        e.preventDefault();
        const { invoice } = this.state;
        
        // E-Arşiv fatura ise farklı route kullan
        if (invoice.documentType === 'EARSIVFATURA' || invoice.documentType === 'EARSIV') {
            window.open(`show-earsiv-invoice/${invoice.id}`);
        } else {
            window.open(`show-service-invoice/${invoice.id}`);
        }
    }
    queryInvoice = async (e) => {
        e.preventDefault();
        try {
            Swal.fire({
                title: 'Fatura durumu sorgulanıyor...',
                text: 'Lütfen bekleyin, işleminiz devam ediyor.',
                icon: 'info',
                allowOutsideClick: false,
                showConfirmButton: false,
                willOpen: () => {
                    Swal.showLoading();
                }
            });
            const response = await apiCall(`business/ksoft/query-invoice/${this.state.invoice.id}`, 'get', null);
            this.getInvoiceInfo();
            Swal.close();
            Swal.fire({
                title: 'Fatura Sorgulama',
                text: response.message,
                icon: response.status,
                confirmButtonText: 'Tamam'
            });
        } catch (error) {
            Swal.close();
            Swal.fire({
                title: 'Fatura Sorgulama',
                text: 'Bir sorun oluştu lütfen daha sonra tekrar deneyiniz!',
                icon: 'error',
                confirmButtonText: 'Tamam'
            });
            console.error(error);

        }

    }
    handleDeleteInvoice = async () => {
        const result = await Swal.fire({
            title: 'Silmek istediğinize emin misiniz?',
            text: "Bu işlem geri alınamaz!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Evet, sil!',
            cancelButtonText: 'Hayır, iptal et',
            preConfirm: async () => {
                const confirmButton = Swal.getConfirmButton();
                const originalButtonText = confirmButton.innerHTML;
                confirmButton.disabled = true;
                confirmButton.innerHTML = ReactDOMServer.renderToString(<ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />);

                try {
                    await apiCall('business/ksoft/delete-invoice/' + this.state.invoice.id, 'delete', null);
                    window.location.href = `service-detail/${this.state.invoice.operation_id}`
                } catch (error) {
                    return false;
                } finally {
                    confirmButton.innerHTML = originalButtonText;
                    confirmButton.disabled = false;
                }
            }
        });

        if (result.isConfirmed) {
            if (result.value) {
                Swal.fire(
                    'Silindi!',
                    'Fatura başarıyla silindi.',
                    'success'
                );
            } else {
                Swal.fire(
                    'Hata!',
                    'Silme işlemi başarısız oldu.',
                    'error'
                );
            }
        }
    }
    handleCreateCari = async () => {
        if (!this.state.formData.due_date || !this.state.formData.payment_status) {
            Swal.fire(
                'Dikkat!',
                'Lütfen vade tarihi ve tahsilat durumunu doldurduğunuzdan emin olun!',
                'warning'
            );
            return;
        }
        const result = await Swal.fire({
            title: 'Uyarı',
            text: "Onaylandığında mevcut toplam tutar üzerinden bir cari kaydı oluşturulacaktır.Cari kayıt mevcut ise ilgili alanlar güncellenecektir." +
                " Not : Ödendi olarak kaydedilir ise alacak tutarı 0 olarak güncellenir.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Kaydet!',
            cancelButtonText: 'İptal et',
            preConfirm: async () => {
                const confirmButton = Swal.getConfirmButton();
                const originalButtonText = confirmButton.innerHTML;
                confirmButton.disabled = true;
                confirmButton.innerHTML = ReactDOMServer.renderToString(<ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />);

                try {
                    await apiCall('business/receivable/cari/save/' + this.state.invoice.id, 'post', { due_date: this.state.formData.due_date, payment_status: this.state.formData.payment_status });

                    return true;
                } catch (error) {
                    return false;
                } finally {
                    confirmButton.innerHTML = originalButtonText;
                    confirmButton.disabled = false;
                }
            }
        });

        if (result.isConfirmed) {
            if (result.value) {
                Swal.fire(
                    'Uyarı!',
                    'İşlem Başarıyla güncellendi.',
                    'success'
                );
            } else {
                Swal.fire(
                    'Hata!',
                    'İşlem başarısız oldu.',
                    'error'
                );
            }
        }
    }

    getXsltList = async (e) => {
        e.preventDefault();
        try {
            Swal.fire({
                title: 'XSLT Listesi Alınıyor...',
                text: 'Lütfen bekleyin, işleminiz devam ediyor.',
                icon: 'info',
                allowOutsideClick: false,
                showConfirmButton: false,
                willOpen: () => {
                    Swal.showLoading();
                }
            });

            const response = await apiCall('business/ksoft/xslt-list', 'get', null);

            Swal.close();

            if (response.isSuccess) {
                // Başarılı response - listeyi göster
                let xsltContent = '<div style="text-align: left; max-height: 400px; overflow-y: auto;">';
                xsltContent += `<p><strong>Döküman Sayısı:</strong> ${response.documentsCount || 'N/A'}</p>`;

                if (response.xsltList && Array.isArray(response.xsltList)) {
                    xsltContent += '<p><strong>XSLT Listesi:</strong></p><ul>';
                    response.xsltList.forEach((xslt, index) => {
                        xsltContent += `<li><strong>${index + 1}. ${xslt.name || 'İsimsiz'}</strong>`;
                        xsltContent += `<br/><small>Varsayılan: ${xslt.isDefault ? 'Evet' : 'Hayır'}</small>`;
                        if (xslt.content) {
                            xsltContent += `<br/><small>İçerik: ${xslt.content.length} karakter</small>`;
                        }
                        xsltContent += '</li>';
                    });
                    xsltContent += '</ul>';
                } else {
                    xsltContent += '<p>XSLT listesi bulunamadı.</p>';
                }
                xsltContent += '</div>';

                Swal.fire({
                    title: 'XSLT Listesi',
                    html: xsltContent,
                    icon: 'success',
                    confirmButtonText: 'Tamam',
                    width: '600px'
                });
            } else {
                // Hatalı response
                Swal.fire({
                    title: 'Hata!',
                    html: `<p><strong>Kod:</strong> ${response.code || 'N/A'}</p>
                           <p><strong>Açıklama:</strong> ${response.explanation || 'Bilinmeyen hata'}</p>
                           <p><strong>Sebep:</strong> ${response.cause || 'N/A'}</p>`,
                    icon: 'error',
                    confirmButtonText: 'Tamam'
                });
            }

        } catch (error) {
            Swal.close();
            Swal.fire({
                title: 'XSLT Listesi Alma Hatası',
                text: error?.response?.data?.message || error.message || 'Bir sorun oluştu, lütfen daha sonra tekrar deneyiniz!',
                icon: 'error',
                confirmButtonText: 'Tamam'
            });
            console.error('getXsltList error:', error);
        }
    }

    handleCancelInvoice = async () => {
        const { invoice } = this.state;
        
        // Sadece E-Arşiv için iptal nedeni ve tarihi sor
        let cancelReason = '';
        let cancelDate = new Date().toISOString().split('T')[0]; // YYYY-MM-DD formatı
        
        if (invoice.documentType === 'EARSIVFATURA' || invoice.documentType === 'EARSIV') {
            const reasonResult = await Swal.fire({
                title: 'E-Arşiv Fatura İptal',
                html: `
                    <div style="text-align: left; padding: 15px 20px;">
                        <p style="margin-bottom: 20px; color: #666; font-size: 14px;">
                            E-Arşiv fatura iptal bilgilerini giriniz:
                        </p>
                        
                        <div style="margin-bottom: 20px;">
                            <label for="cancel_reason" style="display: block; font-weight: 600; margin-bottom: 8px; font-size: 13px; color: #333;">
                                İptal Nedeni <span style="color: red;">*</span>
                            </label>
                            <textarea 
                                id="cancel_reason" 
                                placeholder="İptal nedenini yazınız..." 
                                style="width: 100%; 
                                       padding: 12px; 
                                       font-size: 14px; 
                                       border: 1px solid #d1d5db; 
                                       border-radius: 6px; 
                                       resize: vertical; 
                                       min-height: 80px;
                                       font-family: inherit;
                                       box-sizing: border-box;"
                            ></textarea>
                        </div>
                        
                        <div style="margin-bottom: 20px;">
                            <label for="cancel_date" style="display: block; font-weight: 600; margin-bottom: 8px; font-size: 13px; color: #333;">
                                İptal Tarihi <span style="color: red;">*</span>
                            </label>
                            <input 
                                type="date" 
                                id="cancel_date" 
                                value="${cancelDate}" 
                                style="width: 100%; 
                                       padding: 12px; 
                                       font-size: 14px; 
                                       border: 1px solid #d1d5db; 
                                       border-radius: 6px;
                                       box-sizing: border-box;" 
                            />
                        </div>
                        
                        <div style="padding: 12px; background: #fff3cd; border-left: 4px solid #ffc107; border-radius: 4px;">
                            <small style="color: #856404; font-size: 12px; line-height: 1.5;">
                                <i class="fa fa-info-circle" style="margin-right: 4px;"></i>
                                <strong>Not:</strong> E-Arşiv fatura iptali için GİB tarafından iptal nedeni ve tarihi zorunludur.
                            </small>
                        </div>
                    </div>
                `,
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: '<i class="fa fa-arrow-right"></i> Devam Et',
                cancelButtonText: '<i class="fa fa-times"></i> Vazgeç',
                confirmButtonColor: '#d33',
                cancelButtonColor: '#6c757d',
                width: '550px',
                customClass: {
                    htmlContainer: 'swal2-html-container-no-padding'
                },
                preConfirm: () => {
                    const reason = document.getElementById('cancel_reason').value.trim();
                    const date = document.getElementById('cancel_date').value;
                    
                    if (!reason) {
                        Swal.showValidationMessage('Lütfen iptal nedeni giriniz!');
                        return false;
                    }
                    if (reason.length < 5) {
                        Swal.showValidationMessage('İptal nedeni en az 5 karakter olmalıdır!');
                        return false;
                    }
                    if (!date) {
                        Swal.showValidationMessage('Lütfen iptal tarihi seçiniz!');
                        return false;
                    }
                    
                    return { reason, date };
                }
            });
            
            if (!reasonResult.isConfirmed) {
                return; // İptal edildi
            }
            
            cancelReason = reasonResult.value.reason;
            cancelDate = reasonResult.value.date;
        }
        
        const result = await Swal.fire({
            title: 'Fatura İptal',
            html: `
                <p>Faturayı iptal etmek istediğinize emin misiniz?</p>
                <p style="font-size: 12px; color: #666; margin-top: 10px;">
                    <strong>Fatura No:</strong> ${this.state.invoice.documentId || 'N/A'}<br/>
                    <strong>Fatura Tipi:</strong> ${this.state.invoice.documentType || 'N/A'}
                    ${cancelReason ? `<br/><strong>İptal Nedeni:</strong> ${cancelReason}` : ''}
                    ${cancelDate && (invoice.documentType === 'EARSIVFATURA' || invoice.documentType === 'EARSIV') ? `<br/><strong>İptal Tarihi:</strong> ${cancelDate}` : ''}
                </p>
            `,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Evet, İptal Et!',
            cancelButtonText: 'Vazgeç',
            preConfirm: async () => {
                const confirmButton = Swal.getConfirmButton();
                const originalButtonText = confirmButton.innerHTML;
                confirmButton.disabled = true;
                confirmButton.innerHTML = ReactDOMServer.renderToString(<ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />);

                try {
                    // E-Arşiv için hem neden hem tarih gönder, E-Fatura için sadece neden (opsiyonel)
                    const payload = (invoice.documentType === 'EARSIVFATURA' || invoice.documentType === 'EARSIV') 
                        ? { cancel_reason: cancelReason, cancel_date: cancelDate }
                        : cancelReason ? { cancel_reason: cancelReason } : null;
                        
                    const response = await apiCall('business/ksoft/cancel-invoice/' + this.state.invoice.id, 'post', payload);
                    await this.getInvoiceInfo();
                    return { success: true, message: response.message, explanation: response.explanation };
                } catch (error) {
                    const errorMessage = error?.response?.data?.message || 'Fatura iptal edilemedi. Lütfen daha sonra tekrar deneyiniz.';
                    const errorCause = error?.response?.data?.cause || '';
                    const errorCode = error?.response?.data?.code || '';

                    return {
                        success: false,
                        message: errorMessage,
                        cause: errorCause,
                        code: errorCode
                    };
                } finally {
                    confirmButton.innerHTML = originalButtonText;
                    confirmButton.disabled = false;
                }
            }
        });

        if (result.isConfirmed && result.value) {
            if (result.value.success) {
                Swal.fire(
                    'Başarılı!',
                    result.value.message || 'Fatura başarıyla iptal edildi.',
                    'success'
                );
            } else {
                let errorHtml = `<p>${result.value.message}</p>`;
                if (result.value.cause) {
                    errorHtml += `<p style="font-size: 12px; color: #666; margin-top: 10px;"><strong>Sebep:</strong> ${result.value.cause}</p>`;
                }
                if (result.value.code) {
                    errorHtml += `<p style="font-size: 12px; color: #666;"><strong>Kod:</strong> ${result.value.code}</p>`;
                }

                Swal.fire({
                    title: 'Hata!',
                    html: errorHtml,
                    icon: 'error'
                });
            }
        }
    }
    render() {
        const { invoice, invoiceDraftDeleteLoading, invoiceConfirmLoading } = this.state;
        const { userPermissions } = this.props;
        const userHasCreateInvoice = userPermissions.includes('invoice process');
        const { withholdingRate, totalPrice, totalKdv, totalWithKdv, totalDiscount, totalWithholding } = this.calculateTotals();
        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div>
                    <div className="page-loader-wrapper" style={{ display: this.state.isLoad ? 'block' : 'none' }}>
                        <div className="loader" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <div className="m-t-30">
                                <img src={require('../../assets/images/logo-white.png')} width="150" alt="Lucid" />
                            </div>
                            <p>Yükleniyor</p>
                            <ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />
                        </div>
                    </div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="Fatura detayları"
                            Breadcrumb={[
                                { name: "Faturalar", navigate: "" },
                                { name: "Detay", navigate: "" },
                            ]}
                        />
                        <div className="row clearfix">
                            <div className="col-lg-12">
                                <div className="card">
                                    <div>
                                        {invoice && (
                                            <div className="body" style={{padding: '20px'}}>
                                                <div className="d-flex justify-content-between align-items-center flex-wrap" style={{marginBottom: '20px'}}>
                                                    <div>
                                                        <h4 style={{color: "#333", fontWeight: "600", margin: 0, marginBottom: '5px'}}>
                                                            Plaka: <span className="text-cyan">{invoice.plate?.toUpperCase() || "Plaka Bulunamadı!"}</span>
                                                        </h4>
                                                        <p style={{margin: 0, color: '#666', fontSize: '14px'}}>
                                                            Fatura No: <span className="text-info font-weight-bold">{invoice.documentId || '-'}</span>
                                                            <span style={{margin: '0 10px'}}>|</span>
                                                            Kontör: <span className="text-info font-weight-bold">{this.state.currentCredit} Adet</span>
                                                        </p>
                                                    </div>
                                                    <div className="d-flex align-items-center" style={{gap: '10px'}}>
                                                        <span className={`badge ${invoice.status === 'draft' ? 'badge-secondary' :
                                                                invoice.status === 'running' ? 'badge-primary' :
                                                                    invoice.status === 'done' ? 'badge-success' :
                                                                        invoice.status === 'cancel' ? 'badge-danger' :
                                                                            invoice.status === 'unknown' ? 'badge-danger' :
                                                                                invoice.status === 'error' ? 'badge-danger' : 'badge-warning'
                                                            }`}
                                                              style={{fontSize: '13px', padding: '6px 12px'}}>
                                                            <i className={`fa ${invoice.status === 'done' ? 'fa-check' : invoice.status === 'draft' ? 'fa-file-text-o' : invoice.status === 'running' ? 'fa-spinner' : 'fa-times'}`}></i>
                                                            &nbsp;{invoice.status === 'draft' ? 'Taslak' :
                                                                invoice.status === 'running' ? 'İşlemde' :
                                                                    invoice.status === 'done' ? 'Resmileşti' :
                                                                        invoice.status === 'cancel' ? 'İptal' :
                                                                            invoice.status === 'unknown' ? 'Bilinmeyen' :
                                                                                invoice.status === 'error' ? 'Hata' : 'Bilinmeyen'}
                                                        </span>
                                                        {invoice.status === 'running' || invoice.status === 'error' ? (
                                                            <button onClick={this.queryInvoice}
                                                                className="btn btn-outline-secondary btn-sm">
                                                                <i className="fa fa-database"></i> Durum Sorgula
                                                            </button>
                                                        ) : null}
                                                        {invoice.documentUuid && invoice.status !== 'draft' && (
                                                            <button onClick={this.showInvoice}
                                                                className="btn btn-success btn-sm">
                                                                <i className="fa fa-file-pdf-o"></i> PDF Görüntüle
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        <div className="body" style={{padding: '20px'}}>
                                            {invoice.customer && (
                                                <div className="row">
                                                    {/* Müşteri Bilgileri */}
                                                    <div className="col-lg-6 col-md-12 mb-3">
                                                        <div style={{padding: '15px', background: '#f8f9fa', borderRadius: '8px', height: '100%'}}>
                                                            <div className="d-flex align-items-center mb-3">
                                                                <img
                                                                    alt="User"
                                                                    className="user-photo"
                                                                    style={{width: '60px', height: '60px', borderRadius: '50%', marginRight: '15px'}}
                                                                    src={`https://ui-avatars.com/api/?name=${invoice.customer.name}&color=7F9CF5&background=EBF4FF`}
                                                                />
                                                                <div style={{flex: 1}}>
                                                                    <h6 className="text-cyan font-weight-bold mb-0">Müşteri Bilgileri</h6>
                                                                </div>
                                                                {invoice.customer_id && (
                                                                    <button onClick={this.openCustomerDetail}
                                                                       className="btn btn-outline-info btn-sm">
                                                                        <i className="fa fa-external-link"></i>
                                                                    </button>
                                                                )}
                                                            </div>
                                                            <div style={{display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px"}}>
                                                                <div>
                                                                    <small className="text-muted d-block" style={{fontSize: '12px', fontWeight: '600'}}>Ad Soyad</small>
                                                                    <strong style={{fontSize: '14px'}}>{invoice.customer.name + ' ' + invoice.customer.surname}</strong>
                                                                </div>
                                                                <div>
                                                                    <small className="text-muted d-block" style={{fontSize: '12px', fontWeight: '600'}}>Vergi/TC No</small>
                                                                    <strong style={{fontSize: '14px'}}>{invoice.customer.tax_no || 'Belirtilmemiş'}</strong>
                                                                </div>
                                                                <div style={{gridColumn: '1 / -1'}}>
                                                                    <small className="text-muted d-block" style={{fontSize: '12px', fontWeight: '600'}}>Ünvan</small>
                                                                    <strong style={{fontSize: '14px'}}>{invoice.customer.title || 'Belirtilmemiş'}</strong>
                                                                </div>
                                                                <div>
                                                                    <small className="text-muted d-block" style={{fontSize: '12px', fontWeight: '600'}}>Vergi Dairesi</small>
                                                                    <strong style={{fontSize: '14px'}}>{invoice.customer.tax_district || 'Belirtilmemiş'}</strong>
                                                                </div>
                                                                <div style={{gridColumn: '2 / -1'}}>
                                                                    <small className="text-muted d-block" style={{fontSize: '12px', fontWeight: '600'}}>Adres</small>
                                                                    <strong style={{fontSize: '14px'}}>{invoice.customer.address || 'Belirtilmemiş'}</strong>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Fatura Bilgileri */}
                                                    <div className="col-lg-6 col-md-12 mb-3">
                                                        <div style={{padding: '15px', background: '#f8f9fa', borderRadius: '8px', height: '100%'}}>
                                                            <h6 className="text-cyan font-weight-bold mb-3">Fatura Bilgileri</h6>
                                                            <div style={{display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px"}}>
                                                                <div>
                                                                    <small className="text-muted d-block" style={{fontSize: '12px', fontWeight: '600'}}>Fatura No</small>
                                                                    <strong style={{fontSize: '14px'}}>{invoice.documentId || '-'}</strong>
                                                                </div>
                                                                <div>
                                                                    <small className="text-muted d-block" style={{fontSize: '12px', fontWeight: '600'}}>Fatura Tipi</small>
                                                                    <strong style={{fontSize: '14px'}}>{invoice.documentType || '-'}</strong>
                                                                </div>
                                                                <div>
                                                                    <small className="text-muted d-block" style={{fontSize: '12px', fontWeight: '600'}}>Plaka</small>
                                                                    <strong style={{fontSize: '14px'}}>{invoice.plate?.toUpperCase() || '-'}</strong>
                                                                </div>
                                                                <div>
                                                                    <small className="text-muted d-block" style={{fontSize: '12px', fontWeight: '600'}}>Durum</small>
                                                                    <span className={`badge ${invoice.status === 'draft' ? 'badge-secondary' :
                                                                            invoice.status === 'running' ? 'badge-primary' :
                                                                                invoice.status === 'done' ? 'badge-success' :
                                                                                    invoice.status === 'cancel' ? 'badge-danger' :
                                                                                        invoice.status === 'unknown' ? 'badge-danger' :
                                                                                            invoice.status === 'error' ? 'badge-danger' : 'badge-warning'
                                                                        }`}
                                                                          style={{fontSize: '12px', padding: '4px 8px'}}>
                                                                        {invoice.status === 'draft' ? 'Taslak' :
                                                                            invoice.status === 'running' ? 'İşlemde' :
                                                                                invoice.status === 'done' ? 'Resmileşti' :
                                                                                    invoice.status === 'cancel' ? 'İptal' :
                                                                                        invoice.status === 'unknown' ? 'Bilinmeyen' :
                                                                                            invoice.status === 'error' ? 'Hata' : 'Bilinmeyen'}
                                                                    </span>
                                                                </div>
                                                                {invoice.state_explanation && (
                                                                    <div style={{gridColumn: '1 / -1'}}>
                                                                        <small className="text-muted d-block" style={{fontSize: '12px', fontWeight: '600'}}>Detay</small>
                                                                        <strong style={{fontSize: '13px'}}>{invoice.state_explanation}</strong>
                                                                    </div>
                                                                )}
                                                                {invoice.status === 'cancel' && invoice.cancel_reason && (
                                                                    <div style={{gridColumn: '1 / -1'}}>
                                                                        <small className="text-muted d-block" style={{fontSize: '12px', fontWeight: '600'}}>
                                                                            <i className="fa fa-ban" style={{marginRight: '4px', color: '#dc3545'}}></i>
                                                                            İptal Nedeni
                                                                        </small>
                                                                        <div style={{
                                                                            fontSize: '13px',
                                                                            padding: '10px',
                                                                            background: '#ffebee',
                                                                            borderLeft: '4px solid #dc3545',
                                                                            borderRadius: '4px',
                                                                            marginTop: '6px',
                                                                            color: '#721c24'
                                                                        }}>
                                                                            {invoice.cancel_reason}
                                                                        </div>
                                                                    </div>
                                                                )}
                                                                {invoice.documentUuid && (
                                                                    <div style={{gridColumn: '1 / -1'}}>
                                                                        <small className="text-muted d-block" style={{fontSize: '12px', fontWeight: '600'}}>Fatura UUID</small>
                                                                        <strong style={{fontSize: '13px', wordBreak: 'break-all'}}>{invoice.documentUuid}</strong>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>

                                    </div>
                                    <div className="body" style={{padding: '20px', background: '#f8f9fa'}}>
                                        <h6 className="text-cyan font-weight-bold mb-3">
                                            <i className="fa fa-edit"></i> Cari Bilgileri
                                        </h6>
                                        <div style={{background: '#fff', padding: '20px', borderRadius: '8px'}}>
                                            <div className="row">
                                                <div className="col-lg-6 col-md-12 mb-3">
                                                    <div className="form-group mb-0">
                                                        <label htmlFor="due_date" className="font-weight-bold text-cyan" style={{fontSize: '13px'}}>
                                                            Vade Tarihi
                                                        </label>
                                                        <input name="due_date"
                                                            id="due_date"
                                                            className="form-control"
                                                            type="date"
                                                            value={this.state.formData.due_date}
                                                            onChange={this.handleInvoiceChange}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-md-12 mb-3">
                                                    <div className="form-group mb-0">
                                                        <label htmlFor="payment_status"
                                                            className="font-weight-bold text-cyan" style={{fontSize: '13px'}}>
                                                            Tahsilat Durumu
                                                        </label>
                                                        <select name="payment_status"
                                                            id='payment_status'
                                                            className="form-control"
                                                            value={this.state.formData.payment_status}
                                                            onChange={this.handleInvoiceChange}>
                                                            <option value="">Seçiniz</option>
                                                            <option value="paid">Ödendi</option>
                                                            <option value="unpaid">Ödenmedi</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="text-right" style={{marginTop: '15px', paddingTop: '15px', borderTop: '1px solid #e9ecef'}}>
                                                <button disabled={!userHasCreateInvoice}
                                                    onClick={this.handleCreateCari}
                                                    className="btn btn-info">
                                                    <i className="fa fa-save"></i> Kaydet
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="body">
                                        <div className="row clearfix">
                                            <div className="col-lg-12">
                                                {invoice.operation && JSON.parse(invoice.operation.process).map((process, index) => (
                                                    <div key={index} className="form-row align-items-end mb-3">

                                                        <div className="col-lg">
                                                            <label htmlFor={`process`} style={{fontSize: '12px', fontWeight: '600'}}>Ürün/Hizmet</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                id={`process`}
                                                                placeholder="Ürün/Hizmet"
                                                                value={process.process}
                                                                readOnly
                                                            />
                                                        </div>

                                                        <div className="col-lg">
                                                            <label htmlFor={`unit`} style={{fontSize: '12px', fontWeight: '600'}}>Birim</label>
                                                            <select
                                                                id={`unit`}
                                                                className="form-control"
                                                                value={process.unit}
                                                                disabled>
                                                                <option value="">Birim</option>
                                                                <option value="C62">Adet</option>
                                                                <option value="BX">Kutu</option>
                                                                <option value="PA">Paket</option>
                                                                <option value="Kgm">Kg</option>
                                                                <option value="Ltr">Litre</option>
                                                                <option value="M2">M2</option>
                                                                <option value="M3">M3</option>
                                                                <option value="Pr">Çift</option>
                                                            </select>
                                                        </div>

                                                        <div className="col-lg">
                                                            <label htmlFor={`quantity`} style={{fontSize: '12px', fontWeight: '600'}}>Miktar</label>
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                id={`quantity`}
                                                                placeholder="Miktar"
                                                                value={process.quantity}
                                                                readOnly
                                                            />
                                                        </div>
                                                        <div className="col-lg">
                                                            <label htmlFor={`kdv`} style={{fontSize: '12px', fontWeight: '600'}}>Kdv Oranı (%)</label>
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                id={`kdv`}
                                                                placeholder="Kdv Oranı"
                                                                value={process.kdv}
                                                                readOnly
                                                            />
                                                        </div>
                                                        <div className="col-lg">
                                                            <label htmlFor={`discount`} style={{fontSize: '12px', fontWeight: '600'}}>İndirim Oranı (%)</label>
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                id={`discount`}
                                                                placeholder="indirim Oranı"
                                                                value={process.discount}
                                                                readOnly
                                                            />
                                                        </div>
                                                        <div className="col-lg">
                                                            <label htmlFor={`price`} style={{fontSize: '12px', fontWeight: '600'}}>Tutar</label>
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                id={`price`}
                                                                placeholder="Tutar"
                                                                value={process.price}
                                                                readOnly
                                                            />
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                        <div className="row clearfix">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label className="font-weight-bold text-cyan" style={{fontSize: '13px'}}>
                                                        Fatura Açıklaması
                                                    </label>
                                                    <div className="form-control" style={{backgroundColor: '#f8f9fa', minHeight: '80px', padding: '10px', border: '1px solid #ced4da'}}>
                                                        {this.state.formData.description || 'Açıklama bulunmuyor'}
                                                    </div>
                                                    <small className="form-text text-muted">
                                                        Bu açıklama fatura XML'inde yer almaktadır.
                                                    </small>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row clearfix">
                                            <div className="col-md-6">

                                            </div>
                                            <div className="col-md-6 text-right">
                                                <p className="m-b-0">
                                                    <b>Ara Toplam:</b> {formattedPrice(totalPrice)}
                                                </p>
                                                {totalDiscount > 0 && (
                                                    <p className="m-b-0 mt-2 ml-3"><b>İndirim
                                                        Toplamı:</b> {formattedPrice(totalDiscount)}</p>
                                                )}
                                                {totalKdv > 0 && (
                                                    <p className="m-b-0 mt-2"><b>Toplam KDV:</b> {formattedPrice(totalKdv)}</p>
                                                )}
                                                {totalWithholding > 0 && (
                                                    <p id="tevkifatTotal" className="m-b-0 mt-2 ml-3"><b>Tevkifat
                                                        Tutarı:</b> {formattedPrice(totalWithholding)}
                                                    </p>
                                                )}
                                                {withholdingRate > 0 && (
                                                    <p className="m-b-0 mt-2"><b>Tevkifat Oranı:</b> {withholdingRate}%
                                                    </p>
                                                )}

                                                <h3 className="m-b-0 m-t-10">Genel Toplam: {formattedPrice(totalWithKdv)}</h3>
                                            </div>


                                            <div className="col-lg-12 d-flex justify-content-end">
                                                <div className="hidden-print col-md-6 text-right">
                                                    <hr />
                                                    {
                                                        /*
                                                        <button className="btn btn-outline-secondary mr-1">
                                                        <i onClick={this.printInvoice} className="icon-printer"></i>
                                                        </button>
                                                         */
                                                    }

                                                    {invoice ? (
                                                        <>
                                                            {/* ✅ STATUS'E GÖRE BUTON GÖRÜNÜRLÜĞÜ */}

                                                            {/* 📝 DRAFT: Tüm butonlar (Sil, Taslak Oluştur, Resmileştir) */}
                                                            {invoice.status === "draft" && (
                                                                <>
                                                                    {/* Faturayı Sil */}
                                                                    {invoiceDraftDeleteLoading ? (
                                                                        <button className="btn btn-outline-danger mr-1" disabled
                                                                            style={{ textAlign: "-webkit-center" }}>
                                                                            Siliniyor...
                                                                            <ReactLoading type="spin" width={'24px'}
                                                                                height={'24px'} color="#268bd2" />
                                                                        </button>
                                                                    ) : (
                                                                        <button
                                                                            disabled={!userHasCreateInvoice}
                                                                            onClick={this.handleDeleteInvoice}
                                                                            className="btn btn-outline-danger mr-1">
                                                                            <i className="fa fa-trash"></i> Faturayı Sil
                                                                        </button>
                                                                    )}


                                                                    {/* Resmileştir */}
                                                                    {invoiceConfirmLoading ? (
                                                                        <button className="btn btn-outline-success" disabled
                                                                            style={{ textAlign: "-webkit-center" }}>
                                                                            Gönderiliyor...
                                                                            <ReactLoading type="spin" width={'24px'}
                                                                                height={'24px'} color="#268bd2" />
                                                                        </button>
                                                                    ) : (
                                                                        <button
                                                                            disabled={!userHasCreateInvoice}
                                                                            onClick={this.handleConfirmInvoice}
                                                                            className="btn btn-outline-success">
                                                                            <i className="fa fa-send"></i> Faturayı Gönder (Resmileştir)
                                                                        </button>
                                                                    )}
                                                                </>
                                                            )}

                                                            {/* ⏱️ RUNNING: Sadece İptal Et */}
                                                            {invoice.status === "running" && (
                                                                <button
                                                                    disabled={!userHasCreateInvoice}
                                                                    onClick={this.handleCancelInvoice}
                                                                    className="btn btn-outline-danger">
                                                                    <i className="fa fa-times"></i> İptal Et
                                                                </button>
                                                            )}

                                                            {/* ✅ DONE: Sadece mesaj (buton yok) */}
                                                            {invoice.status === "done" && (
                                                                <button className="btn btn-success" disabled>
                                                                    <i className="fa fa-check"></i> Fatura işlemi başarıyla tamamlandı.
                                                                </button>
                                                            )}

                                                            {/* ❌ CANCEL, ERROR, UNKNOWN: Sadece Sil butonu */}
                                                            {(invoice.status === "cancel" || invoice.status === "error" || invoice.status === "unknown") && (
                                                                <>
                                                                    {/* Status mesajı */}
                                                                    {invoice.status === "cancel" && (
                                                                        <button className="btn btn-danger mr-1" disabled>
                                                                            <i className="fa fa-ban"></i> Fatura işlemi iptal edildi.
                                                                        </button>
                                                                    )}
                                                                    {invoice.status === "error" && (
                                                                        <button className="btn btn-danger mr-1" disabled>
                                                                            <i className="fa fa-exclamation-triangle"></i> Fatura işlenirken hata oluştu.
                                                                        </button>
                                                                    )}
                                                                    {invoice.status === "unknown" && (
                                                                        <button className="btn btn-secondary mr-1" disabled>
                                                                            <i className="fa fa-question"></i> Fatura durumu belirsiz.
                                                                        </button>
                                                                    )}

                                                                    {/* Sil butonu */}
                                                                    {invoiceDraftDeleteLoading ? (
                                                                        <button className="btn btn-outline-danger" disabled
                                                                            style={{ textAlign: "-webkit-center" }}>
                                                                            Siliniyor...
                                                                            <ReactLoading type="spin" width={'24px'}
                                                                                height={'24px'} color="#268bd2" />
                                                                        </button>
                                                                    ) : (
                                                                        <button
                                                                            disabled={!userHasCreateInvoice}
                                                                            onClick={this.handleDeleteInvoice}
                                                                            className="btn btn-outline-danger">
                                                                            <i className="fa fa-trash"></i> Faturayı Sil
                                                                        </button>
                                                                    )}
                                                                </>
                                                            )}
                                                        </>
                                                    ) : (
                                                        <div className="alert alert-danger text-center"> Fatura oluşturulurken bir sorun oluştu.</div>
                                                    )}
                                                </div>
                                            </div>
                                            <style>
                                                {`
                                                  #dropdown-basic::after {
                                                      display: none;                                                     
                                                  }
                                                `}
                                            </style>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );

    }
}

const mapStateToProps = ({ ioTReducer }) => ({
    isSecuritySystem: ioTReducer.isSecuritySystem,
});

export default withPermissions(withRouter(connect(mapStateToProps, {})(InvoiceDetail)));
